// src/admin/lib/adminApi.js
// Same backend base URL as lib/api.js (same n8n instance, /webhook/api
// prefix) -- admin endpoints just live under /admin/* on that same base.
// Kept as a separate axios instance (rather than reusing the merchant
// `api` export) so the Authorization header always carries the admin
// token, never the merchant one, regardless of which session happens to
// be set in localStorage at the time.

import axios from "axios";
import { getAdminSessionToken, clearAdminSession } from "@/admin/lib/adminAuth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/webhook/api`;

const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const token = getAdminSessionToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearAdminSession();
      if (
        typeof window !== "undefined" &&
        window.location.pathname !== "/admin/login"
      ) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export default adminApi;
